export class Utils {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static isNumber(val: any): boolean {
    return typeof val === 'number';
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static isDefined(val: any): boolean {
    return val !== undefined;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static isObject(val: any): boolean {
    return typeof val === 'object';
  }

}

export enum RESIZE_DIRECTIONS {
  topLeft = 'NW',
  top = 'N',
  topRight = 'NE',
  right = 'E',
  bottomRight = 'SE',
  bottom = 'S',
  bottomLeft = 'SW',
  left = 'W'
}

export const ALL_DIRECTIONS: RESIZE_DIRECTIONS[] = [
  RESIZE_DIRECTIONS.bottom,
  RESIZE_DIRECTIONS.left,
  RESIZE_DIRECTIONS.right,
  RESIZE_DIRECTIONS.top,
  RESIZE_DIRECTIONS.bottomLeft,
  RESIZE_DIRECTIONS.bottomRight,
  RESIZE_DIRECTIONS.topLeft,
  RESIZE_DIRECTIONS.topRight
];
